<template>
  <div class="page-container">
    <searchable-grid title="Clients" :column-defs="columnDefs" :get-rows-promise="getRows" @cellDoubleClicked="onCellDoubleClicked">
      <template slot="actions">
        <el-button type="primary" icon="fa fa-plus" @click="createClientDialogVisible = true">Create Client</el-button>
        <el-button class="ml-0" type="primary" icon="fa fa-download" @click="importClientDialogVisible = true">Import Client</el-button>
      </template>
    </searchable-grid>
    <el-dialog
      title="Create Client"
      :visible.sync="createClientDialogVisible"
      width="600px">
      <edit-client-dialog @close="createClientDialogVisible = false" @clientUpdated="onClientCreated"></edit-client-dialog>
    </el-dialog>
    <el-dialog
      title="Import Client"
      :visible.sync="importClientDialogVisible"
      width="400px">
      <import-client-dialog @close="importClientDialogVisible = false" @success="onClientCreated"></import-client-dialog>
    </el-dialog>
  </div>
</template>

<script>
import api from '@/api';
import SearchableGrid from '@/components/grid/SearchableGrid.vue';
import EditClientDialog from '@/components/dialog-content/EditClient.vue';
import ImportClientDialog from '@/components/dialog-content/ImportClient.vue';

export default {
  data() {
    return {
      createClientDialogVisible: false,
      importClientDialogVisible: false,
      columnDefs: [
        {
          headerName: '#',
          width: 50,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          pinned: true,
        },
        {
          headerName: 'SSN',
          field: 'ssn',
          sortable: false,
          filterParams: {
            applyButton: true,
            clearButton: true,
            filterOptions: ['equals'],
            defaultOption: 'equals',
          },
          cellRenderer: (params) => {
            if (params.value !== undefined) {
              return params.value;
            }
            return '<i class="el-icon-loading"></i>';
          },
        },
        {
          headerName: 'First',
          field: 'firstName',
        },
        {
          headerName: 'Last',
          field: 'lastName',
        },
        {
          headerName: 'City',
          field: 'city',
        },
        {
          headerName: 'State',
          field: 'state',
        },
        {
          headerName: 'Zip',
          field: 'zip',
        },
        {
          headerName: 'Email',
          field: 'email',
        },
        {
          headerName: 'Phone',
          field: 'phone',
        },
        {
          headerName: 'Date Added',
          field: 'dateAdded',
          filter: 'date',
        },
        {
          headerName: 'Office Id',
          field: 'office',
        },
      ],
    };
  },
  methods: {
    getRows(params) {
      return api.client.getGridData(params);
    },
    onCellDoubleClicked(event) {
      if (event.data && event.data.id) {
        this.$router.push({ name: 'clientDetail', params: { id: event.data.id } });
      }
    },
    onClientCreated(client) {
      this.$router.push({ name: 'clientDetail', params: { id: client.id } });
    },
  },
  components: {
    SearchableGrid,
    EditClientDialog,
    ImportClientDialog,
  },
};

</script>

<style lang="scss" scoped>

</style>
